/******************************************************************
  Alexander Self
  Redux Actions
  - Any action that takes place throughout the application should be created here
*******************************************************************/
/* Auth Actions */
export const SIGNIN_USER = 'SIGNIN_USER',
             AUTH_USER = 'AUTH_USER',
             UNAUTH_USER = 'UNAUTH_USER',
             AUTH_ERROR = 'AUTH_ERROR',
             FETCH_USER_PROFILE = 'FETCH_USER_PROFILE';

/* Misc Actions */
export const FETCH_PAY_PERIOD = 'FETCH_PAY_PERIOD',
             NULL = 'NULL';

/* Map Actions */
export const SET_MAP_VIEW = 'SET_MAP_VIEW',
             SET_FIELD_VIEW = 'SET_FIELD_VIEW',
             SET_MAP_LOCATION = 'SET_MAP_LOCATION',
             FETCH_FIELD_INFORMATION = 'FETCH_FIELD_INFORMATION';

/* Timesheet Actions */
export const ERROR = 'ERROR',
             FETCH_MESSAGE = 'FETCH_MESSAGE',
             FETCH_TIMESHEET_DATA = 'FETCH_TIMESHEET_DATA',
             FETCH_SUBACCOUNTS = 'FETCH_SUBACCOUNTS',
             FETCH_FIELDS_BY_LOC = 'FETCH_FIELDS_BY_LOC',
             FETCH_BLOCKS_BY_FIELD = 'FETCH_BLOCKS_BY_FIELD',
             FETCH_TIMESHEETS = 'FETCH_TIMESHEETS',
             FETCH_MY_TIMESHEETS = 'FETCH_MY_TIMESHEETS',
             FETCH_EMPLOYEE_TIMESHEETS = 'FETCH_EMPLOYEE_TIMESHEETS',
             FETCH_TIMESHEET_TO_EDIT = 'FETCH_TIMESHEETS_TO_EDIT',
             FETCH_TIMESHEETS_TO_DELETE = 'FETCH_TIMESHEETS_TO_DELETE',
             ADD_EMPLOYEE_TO_TIMESHEET = 'ADD_EMPLOYEE_TO_TIMESHEET',
             REMOVE_EMPLOYEE_FROM_TIMESHEET = 'REMOVE_EMPLOYEE_FROM_TIMESHEET',
             ADD_WORK_TO_TIMESHEET = 'ADD_WORK_TO_TIMESHEET',
             REMOVE_WORK_FROM_TIMESHEET = 'REMOVE_WORK_FROM_TIMESHEET',
             ADD_EMPLOYEE_TO_GANG_TIMESHEET = 'ADD_EMPLOYEE_TO_GANG_TIMESHEET',
             REMOVE_EMPLOYEE_FROM_GANG_TIMESHEET = 'REMOVE_EMPLOYEE_FROM_GANG_TIMESHEET',
             PREPARE_GANG_TIMESHEET = 'PREPARE_GANG_TIMESHEET',
             PREPARE_REG_TIMESHEET = 'PREPARE_REG_TIMESHEET',
             SUBMIT_REG_TIMESHEET = 'SUBMIT_REG_TIMESHEET',
             SUBMIT_GANG_TIMESHEET = 'SUBMIT_GANG_TIMESHEET',
             GET_TIMESHEET_DATES_TO_EDIT = 'GET_TIMESHEET_DATES_TO_EDIT',
             ADD_WORK_TO_EDIT_TIMESHEET = 'ADD_WORK_TO_EDIT_TIMESHEET',
             ADD_HARVEST_TO_EDIT_TIMESHEET = 'ADD_HARVEST_TO_EDIT_TIMESHEET',
             REMOVE_WORK_FROM_EDIT_TIMESHEET = 'REMOVE_WORK_FROM_EDIT_TIMESHEET',
             REMOVE_HARVEST_FROM_EDIT_TIMESHEET = 'REMOVE_HARVEST_FROM_EDIT_TIMESHEET',
             PREPARE_EDIT_TIMESHEET = 'PREPARE_EDIT_TIMESHEET',
             SUBMIT_EDIT_TIMESHEET = 'SUBMIT_EDIT_TIMESHEET',
             DELETE_TIMESHEET = 'DELETE_TIMESHEET',
             EMPLOYEE_AUTOCOMPLETE = 'EMPLOYEE_AUTOCOMPLETE',
             DOWNLOAD_TIMESHEET = 'DOWNLOAD_TIMESHEET',
             SELECT_GANG_FOR_TIMESHEET = 'SELECT_GANG_FOR_TIMESHEET',
             SELECT_GANG_FOR_GANG_TIMESHEET = 'SELECT_GANG_FOR_GANG_TIMESHEET',
             FETCH_MY_EMPLOYEES_TIMESHEET = 'FETCH_MY_EMPLOYEES_TIMESHEET',
             ADD_NEW_GANG_INFO_ROW = 'ADD_NEW_GANG_INFO_ROW',
             SELECT_COST_CENTER_BY_LOCATION = 'SELECT_COST_CENTER_BY_LOCATION',
             EDIT_WORK_IN_TIMESHEET = 'EDIT_WORK_IN_TIMESHEET',
             EDIT_WORK_RECORD = 'EDIT_WORK_RECORD',
             EDIT_WORK_IN_EDIT_TIMESHEET = 'EDIT_WORK_IN_EDIT_TIMESHEET',
             EDIT_WORK_RECORD_EDIT_TS = 'EDIT_WORK_RECORD_EDIT_TS',
             ADD_WORK_TO_GANG_TIMESHEET = 'ADD_WORK_TO_GANG_TIMESHEET',
             EDIT_WORK_IN_GANG_TIMESHEET = 'EDIT_WORK_IN_GANG_TIMESHEET',
             EDIT_GANG_WORK_RECORD = 'EDIT_GANG_WORK_RECORD',
             DELETE_WORK_IN_GANG_TIMESHEET = 'DELETE_WORK_IN_GANG_TIMESHEET',
             SELECT_HARVEST_TO_EDIT = 'SELECT_HARVEST_TO_EDIT',
             EDIT_HARVEST = 'EDIT_HARVEST',
             AUTOFILL_GANG_TIMESHEET = 'AUTOFILL_GANG_TIMESHEET';

/* Schedule Actions */
export const CREATE_SCHEDULE = 'CREATE_SCHEDULE',
             ADD_EMPLOYEE_TO_SCHEDULE = 'ADD_EMPLOYEE_TO_SCHEDULE',
             REMOVE_EMPLOYEE_FROM_SCHEDULE = 'REMOVE_EMPLOYEE_FROM_SCHEDULE',
             ADD_DAILY_WORK_TO_SCHEDULE = 'ADD_DAILY_WORK_TO_SCHEDULE',
             REMOVE_DAILY_WORK_FROM_SCHEDULE = 'REMOVE_DAILY_WORK_FROM_SCHEDULE',
             PREPARE_SCHEDULE = 'PREPARE_SCHEDULE',
             SUBMIT_SCHEDULE = 'SUBMIT_SCHEDULE',
             FETCH_SCHEDULE = 'FETCH_SCHEDULE',
             SET_EMPLOYEE_PRESENCE = 'SET_EMPLOYEE_PRESENCE',
             RESET_EMPLOYEE_PRESENCE = 'RESET_EMPLOYEE_PRESENCE',
             SUBMIT_EMPLOYEE_PRESENCE = 'SUBMIT_EMPLOYEE_PRESENCE',
             FETCH_SCHEDULES_TO_EDIT = 'FETCH_SCHEDULES_TO_EDIT',
             FETCH_SCHEDULE_TO_EDIT = 'FETCH_SCHEDULE_TO_EDIT',
             FETCH_EMPLOYEES_FOR_SCHEDULE = 'FETCH_EMPLOYEES_FOR_SCHEDULE',
             ADD_EMPLOYEE_TO_EDIT_SCHEDULE = 'ADD_EMPLOYEE_TO_EDIT_SCHEDULE',
             REMOVE_EMPLOYEE_FROM_EDIT_SCHEDULE = 'REMOVE_EMPLOYEE_FROM_EDIT_SCHEDULE',
             ADD_DAILY_WORK_TO_EDIT_SCHEDULE = 'ADD_DAILY_WORK_TO_EDIT_SCHEDULE',
             REMOVE_DAILY_WORK_FROM_EDIT_SCHEDULE = 'REMOVE_DAILY_WORK_FROM_EDIT_SCHEDULE',
             PREPARE_EDIT_SCHEDULE = 'PREPARE_EDIT_SCHEDULE',
             SUBMIT_EDITED_SCHEDULE = 'SUBMIT_EDITED_SCHEDULE',
             DELETE_SCHEDULE = 'DELETE_SCHEDULE',
             ADD_GANG_TO_SCHEDULE = 'ADD_GANG_TO_SCHEDULE',
             ADD_GANG_TO_EDIT_SCHEDULE = 'ADD_GANG_TO_EDIT_SCHEDULE',
             FETCH_MY_EMPLOYEES_SCHEDULE = 'FETCH_MY_EMPLOYEES_SCHEDULE',
             VIEW_MY_SCHEDULED_EMPLOYEES = 'VIEW_MY_SCHEDULED_EMPLOYEES';

/* Gang Builder Actions */
export const ADD_GANG_MEMBER = 'ADD_GANG_MEMBER',
             REMOVE_GANG_MEMBER = 'REMOVE_GANG_MEMBER',
             GANG_AUTOCOMPLETE = 'GANG_AUTOCOMPLETE',
             CREATE_GANG = 'CREATE_GANG',
             FETCH_GANGS = 'FETCH_GANGS',
             SELECT_GANG = 'SELECT_GANG',
             SELECT_GANG_TO_EDIT = 'SELECT_GANG_TO_EDIT',
             ADD_GANG_MEMBER_TO_EDIT = 'ADD_GANG_MEMBER_TO_EDIT',
             REMOVE_GANG_MEMBER_FROM_EDIT = 'REMOVE_GANG_MEMBER_FROM_EDIT',
             EDIT_GANG = 'EDIT_GANG',
             GANG_EDIT_AUTOCOMPLETE = 'GANG_EDIT_AUTOCOMPLETE',
             DELETE_GANG = 'DELETE_GANG';

/* Profile Actions */
export const FETCH_EMPLOYEE_TO_EDIT = 'FETCH_EMPLOYEE_TO_EDIT',
             FETCH_LEVEL_EMPLOYEES = 'FETCH_LEVEL_EMPLOYEES',
             FETCH_EMPLOYEE_PROFILE = 'FETCH_EMPLOYEE_PROFILE',
             SUBMIT_EDIT_PROFILE = 'SUBMIT_EDIT_PROFILE',
             CREATE_EMPLOYEE_PROFILE = 'CREATE_EMPLOYEE_PROFILE',
             FETCH_POSITION_TYPE = 'FETCH_POSITION_TYPE',
             CREATE_LOGIN_PROFILE = 'CREATE_LOGIN_PROFILE',
             SUBMIT_EDIT_LOGIN = 'SUBMIT_EDIT_LOGIN',
             DOWNLOAD_EMPLOYEES = 'DOWNLOAD_EMPLOYEES';

/* Dashboard Actions */
export const FETCH_DASHBOARD_DATA = 'FETCH_DASHBOARD_DATA',
             FETCH_INFO_BY_LOCATION = 'FETCH_INFO_BY_LOCATION',
             ENLARGE_GRAPHS = 'ENLARGE_GRAPHS',
             FETCH_HEADCOUNT = 'FETCH_HEADCOUNT',
             SORT_BY_OPERATION = 'SORT_BY_OPERATION',
             FETCH_HOURS_BY_FIELD = 'FETCH_HOURS_BY_FIELD',
             FETCH_MISSING_TIMESHEETS = 'FETCH_MISSING_TIMESHEETS';
/* Equipment Actions */
export const FETCH_EQUIPMENT = 'FETCH_EQUIPMENT',
             SELECT_EQUIPMENT = 'SELECT_EQUIPMENT';

/* Harvest Actions */
export const SELECT_FIELD = 'SELECT_FIELD',
             CREATE_MECH_HARVEST = 'CREATE_MECH_HARVEST',
             FETCH_MECH_HARVEST = 'FETCH_MECH_HARVEST',
             FETCH_MY_MECH_HARVEST = 'FETCH_MY_MECH_HARVEST',
             PREPARE_MECH_HARVEST_TO_CREATE = 'PREPARE_MECH_HARVEST_TO_CREATE',
             PREPARE_MECH_HARVEST_TO_CREATE_2 = 'PREPARE_MECH_HARVEST_TO_CREATE_2',
             PREPARE_MECH_HARVEST_TO_EDIT = 'PREPARE_MECH_HARVEST_TO_EDIT',
             PREPARE_MECH_HARVEST_TO_EDIT_2 = 'PREPARE_MECH_HARVEST_TO_EDIT_2',
             SELECT_REPORT_TYPE = 'SELECT_REPORT_TYPE',
             SET_REPORT_OPTS = 'SET_REPORT_OPTS',
             FETCH_REPORT = 'FETCH_REPORT',
             SELECT_NEW_REPORT = 'SELECT_NEW_REPORT',
             SELECT_HARVEST_TO_MANAGE = 'SELECT_HARVEST_TO_MANAGE',
             RESET_MANAGE_HARVEST = 'RESET_MANAGE_HARVEST',
             FETCH_HARVEST_BY_DATE = 'FETCH_HARVEST_BY_DATE',
             EDIT_MECH_HARVEST = 'EDIT_MECH_HARVEST',
             DELETE_MECH_HARVEST = 'DELETE_MECH_HARVEST',
             ADD_HARVEST_RECORD = 'ADD_HARVEST_RECORD',
             SET_MECH_HARVEST_TO_EDIT = 'SET_MECH_HARVEST_TO_EDIT', // In create/edit form
             EDIT_MECH_HARVEST_RECORD = 'EDIT_MECH_HARVEST_RECORD', // In create/edit form
             DELETE_MECH_HARVEST_RECORD = 'DELETE_MECH_HARVEST_RECORD'; // In create/edit form

/* Alert Actions */
export const  UPDATE_SELECTED_LOCATION = 'UPDATE_SELECTED_LOCATION',
              UPDATE_PREFILL_MESSAGE = 'UPDATE_PREFILL_MESSAGE',
              UPDATE_OPTIONAL_MESSAGE = 'UPDATE_OPTIONAL_MESSAGE',
              NOTIFICATION_SENT = 'NOTIFICATION_SENT',
              UPDATE_SELECTED_GANG = 'UPDATE_SELECTED_GANG',
              TOAST_DISPLAYED = 'TOAST_DISPLAYED',
              UPDATE_MESSAGE_LIST = 'UPDATE_MESSAGE_LIST',
              UPDATE_CHIPS = 'UPDATE_CHIPS',
              REMOVE_CHIP = 'REMOVE_CHIP',
              NOTIFY_SELECTED_EMPLOYEES = 'NOTIFY_SELECTED_EMPLOYEES',
              FETCH_GANGS_FOR_SMS = 'FETCH_GANGS_FOR_SMS',
              FETCH_LOCATIONS = 'FETCH_LOCATIONS',
              SEARCH_MESSAGES_DATABASE = 'SEARCH_MESSAGES_DATABASE';

/* END */



// WEBPACK FOOTER //
// ./src/actions/types.js